import { AccountStatus, AccountType } from "@/modules/account/common/enum";
import type { IAccount } from "@/modules/account/common/types";
import { useGetAccountsQuery } from "@/modules/account/services";
import { INITIAL_PAGE } from "@/shared/common/constants";
import type { IError } from "@/shared/common/types";
import { PageWidgetTemplate } from "@/shared/components";
import type { Dispatch, SetStateAction } from "react";

import { ClosedAccountItem } from "./ClosedAccountItem";

interface Props {
  limit?: number;
  type?: string;
  status?: string;
  isDetailOpen?: boolean;
  selectedAccount?: IAccount | null;
  setSelectedAccount?: Dispatch<SetStateAction<IAccount | null>>;
  setIsOpen?: Dispatch<SetStateAction<boolean>>;
}

export const ClosedAccounts = ({
  limit,
  type = AccountType.SettlementAccount,
  status = AccountStatus.Closed,
  isDetailOpen,
  setSelectedAccount,
  setIsOpen,
}: Props) => {
  const {
    data: accountList,
    isFetching,
    isError,
    error,
    refetch,
  } = useGetAccountsQuery({
    pageIndex: INITIAL_PAGE,
    pageSize: limit,
    accountType: type,
    accountStatus: status,
  }, {
    refetchOnMountOrArgChange: true,
  });

  const onShowDetails = (account: IAccount) => {
    setSelectedAccount?.(account);
    if (!isDetailOpen) {
      setIsOpen?.(true);
    }
  };

  return (
    <PageWidgetTemplate
      isEmpty={!accountList?.length}
      isFetching={isFetching}
      isError={isError}
      error={error as IError}
      refetch={refetch}
    >
      {accountList?.map((account, i) => (
        <div key={account.id} onClick={() => onShowDetails(account)}>
          <ClosedAccountItem
            {...account}
            index={i}
          />
        </div>
      ))}
    </PageWidgetTemplate>
  );
};
